import { PayloadAction } from '@reduxjs/toolkit';

import actionTypes from '~actionTypes';
import { createNamespacer, createReducer, ReducerHandlers } from '~utils/reducers';

const navNamespacer = createNamespacer('NAV');

interface NavState {
	isSidebarCollapsed: boolean;
}

const initialState: NavState = {
	isSidebarCollapsed: false,
};

const handlers: ReducerHandlers<NavState> = {
	[navNamespacer(actionTypes.nav.SET_IS_SIDEBAR_COLLAPSED)]: (
		state,
		action: PayloadAction<boolean>,
	) => ({
		...state,
		isSidebarCollapsed: action.payload,
	}),
};

export const setIsSidebarCollapsed = (
	payload: boolean,
): { type: string; payload: boolean } => ({
	type: navNamespacer(actionTypes.nav.SET_IS_SIDEBAR_COLLAPSED),
	payload,
});

export default createReducer(initialState, handlers, ['NAV']);
